package dev.lingvo.site.ds

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.styleModifier

/** Reserves the pointer floor in layout, so clipping ancestors cannot trim an extended target. */
fun Modifier.minimumControlHitArea(): Modifier = styleModifier {
    property("min-height", ControlHeight.MD.toString())
    property("min-width", ControlHeight.MD.toString())
}
